module.exports = "<div>\n  <p class=\"Overflow-expandableText\" ng-class=\"{'Overflow-expandableText--expanded' : textExpanded}\" ng-bind-html=\"text\"></p>\n  <p class=\"Link Link--blue Overflow-expandLink\" ng-class=\"{'Overflow-expandableText--moreHidden' : textExpanded}\" ng-click=\"expand()\">+ {{revealText}}</p>\n  <!-- TODO: refactor -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/overflow/overflow.html
// module id = 572
// module chunks = 24